import { useQuery } from '@apollo/client';
import { QueryListResponse, SelectOption } from 'global';

import { DEALER_TIERS_OPTIONS } from '../api';

interface Options {
  skip?: boolean;
}

export const useDealerTiersOptions = ({ skip = false }: Options = {}) => {
  const { data, loading, error } = useQuery<QueryListResponse<SelectOption>>(DEALER_TIERS_OPTIONS, {
    skip,
  });

  return {
    error,
    loading,
    options: data?.result?.list ?? [],
  };
};
